import { render, staticRenderFns } from "./tpv.vue?vue&type=template&id=6d5a8102&scoped=true&"
import script from "./tpv.vue?vue&type=script&lang=js&"
export * from "./tpv.vue?vue&type=script&lang=js&"
import style0 from "./tpv.vue?vue&type=style&index=0&id=6d5a8102&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d5a8102",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBtn,VCard,VContainer,VIcon,VSheet})
